'use strict';

angular.module('amexReconciliationApp')
  .filter('tpdFilter', function ($filter) {
    var dateFormat = $filter('userPreferenceDateFormat');
    var currencyFormat = $filter('userPreferenceCurrencyFormat');

    return function (collection, searchTerm, preferredCurrencyFormat) {
      var filters = [
        function (tpdLine) {
          return dateFormat(_.get(tpdLine, 'orderDate', ''));
        },
        function (tpdLine) {
          return _.get(tpdLine, 'merchantName', '');
        },
        function (tpdLine) {
          return _.get(tpdLine, 'travelerName', '');
        },
        function (tpdLine) {
          return _.get(tpdLine, 'ticketNumber', '');
        },
        function (tpdLine) {
          return _.get(tpdLine, 'invoiceNumber', '');
        },
        function (tpdLine) {
          return _.get(tpdLine, 'lineItems[0].concatenatedAccountingFieldValues', '');
        },
        function (tpdLine) {
          var amount = _.get(tpdLine, 'orderAmount', null);
          return currencyFormat(amount,preferredCurrencyFormat);
        }
      ];

      return _.filter(collection, function (tpdLine) {
        return _.some(filters, function (filter) {
          var filtered = _.toUpper(filter(tpdLine));
          return filtered.indexOf(_.toUpper(searchTerm)) > -1;
        });
      });

    };
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/tpdFilter.js
// module id = 560
// module chunks = 0